import { useState } from 'react'
import { ChevronDown, ChevronUp, HelpCircle } from 'lucide-react'
import { useMinCopy } from '@/i18n/useUiLocale'
import type { RecommendationExplanation } from '@/api/reading'

interface RecommendationWhyPanelProps {
  explanations: RecommendationExplanation[]
  className?: string
}

export function RecommendationWhyPanel({ explanations, className }: RecommendationWhyPanelProps) {
  const { recommendation } = useMinCopy()
  const [expanded, setExpanded] = useState(false)

  if (explanations.length === 0) {
    return null
  }

  return (
    <div className={className} data-testid="recommendation-why-panel">
      <button
        type="button"
        className="inline-flex items-center gap-1.5 text-xs font-medium text-primary hover:underline"
        onClick={() => setExpanded((value) => !value)}
        data-testid="recommendation-why-toggle"
      >
        <HelpCircle className="h-3.5 w-3.5" />
        {recommendation.whyArticle}
        {expanded ? <ChevronUp className="h-3.5 w-3.5" /> : <ChevronDown className="h-3.5 w-3.5" />}
      </button>

      {expanded ? (
        <ul className="mt-3 space-y-2 rounded-lg border border-border/80 bg-muted/30 p-3 text-sm text-muted-foreground">
          {explanations.map((item) => (
            <li key={`${item.reasonCode}-${item.reasonText}`} className="min-w-0 break-words">
              <p>{item.reasonText}</p>
              {item.matchedWords.length > 0 ? (
                <p className="mt-1 break-words text-xs">
                  {recommendation.dueWords}: {item.matchedWords.join(', ')}
                </p>
              ) : null}
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  )
}
